import React from 'react';
import {
  NavigationAndActionArrowBack,
  NavigationAndActionArrowForth,
} from '../icons';
import { ButtonType } from './ButtonType';
import {
  StyledButton,
  StyledButtonIconContainer,
  StyledButtonTextContainer,
} from './styled';

export interface ButtonProps {
  type?: ButtonType;
  text?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  color?: string;
  hoverColor?: string;
  submit?: boolean;
  title?: string;
  ariaLabel?: string;
}

const getButtonIcon = (
  type: ButtonType,
  icon?: React.ReactNode,
): React.ReactNode => {
  /* Text button and secondary action buttons have default icons
   * that can be changed by passing the icon prop to the button component. */
  if (type === ButtonType.Text) {
    return icon || <NavigationAndActionArrowForth />;
  }
  if (type === ButtonType.SecondaryAction) {
    return icon || <NavigationAndActionArrowBack />;
  }
  return icon;
};

export const Button: React.FC<ButtonProps> = ({
  type = ButtonType.Primary,
  text,
  icon,
  onClick,
  disabled = false,
  className,
  color,
  hoverColor,
  submit = false,
  title,
  ariaLabel,
  ...props
}) => {
  const buttonIcon = getButtonIcon(type, icon);

  return (
    <StyledButton
      buttonType={type}
      disabled={disabled}
      onClick={onClick}
      className={className}
      color={color}
      hoverColor={hoverColor}
      type={submit ? 'submit' : 'button'}
      title={title}
      aria-label={ariaLabel}
      {...props}>
      {buttonIcon && (
        <StyledButtonIconContainer buttonType={type}>
          {buttonIcon}
        </StyledButtonIconContainer>
      )}
      <StyledButtonTextContainer buttonType={type}>
        {text}
      </StyledButtonTextContainer>
    </StyledButton>
  );
};
